import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import { Col, Breadcrumb, Button, Card, Row, Input, Table, Badge, Popconfirm, Icon, Message } from 'antd';
import { User } from '../../../models';
import PageHeaderLayout from '../../../layouts/PageHeaderLayout';
import styles from './index.less';

export class UsersContainer extends Component {
  static propTypes = {
    getUsers: PropTypes.func.isRequired,
    removeUser: PropTypes.func.isRequired,
    users: PropTypes.object,
  }

  static defaultProps = {
    users: {},
  }

  constructor(props) {
    super(props);
    this.state = {
      search: '',
      limit: 10,
      current: 1,
    };
  }

  componentDidMount() {
    this.refresh();
  }

  onChange = (pagination, search) => {
    let nextState = {};
    if (search || search === '') {
      nextState.search = search;
    }
    if (pagination && pagination.current !== this.state.current) {
      nextState.current = pagination.current;
    }

    if (Object.keys(nextState).length) {
      this.setState(nextState);
    }
  }

  handleDelete = async (id) => {
    await this.props.removeUser({ body: { id } });
    if (this.props.users.error) {
      Message.error('Админыг устгах амжилтгүй');
    } else {
      Message.success('Админыг устгах амжилттай');
      this.refresh();
    }
  }

  refresh = () => {
    this.props.getUsers();
  }

  remove = () => {
    this.props.removeUser();
  }

  search = () => {
    console.log(this.state.search);
  }

  columns = [{
    title: 'Нэр',
    key: 'name',
    render: (text, record) => (
      <Link to={`users/${record.id}`}>{record.name}</Link>
    ),
  }, {
    title: 'И-Мэйл',
    dataIndex: 'email',
    key: 'email',
  }, {
    title: 'Утасны дугаар',
    dataIndex: 'tel',
    key: 'tel',
  }, {
    title: 'Идэвхтэй эсэх',
    key: 'active',
    render: (text, record) => (record.active ? (
      <Badge status="success" text="Идэвхтэй" />
    ) : (
      <Badge status="default" text="Идэвхгүй" />
    )),
  }, {
    title: 'Үйлдэл',
    width: '160px',
    key: 'action',
    render: (text, record) => (
      <Button.Group size="small">
        <Button>
          <Link to={`/users/${record.id}`}>
            <Icon type="edit" />
          </Link>
        </Button>
        <Popconfirm
          title="Та уг Админыг устгахдаа итгэлтэй байна уу?"
          okText="Тийм"
          cancelText="Үгүй"
          onConfirm={() => { this.handleDelete(record.id); }}
        >
          <Button>
            <Icon type="delete" />
          </Button>
        </Popconfirm>
      </Button.Group>
    ),
  }]

  render() {
    const breadcrumb = (
      <Col span={24}>
        <div className={styles.pageTop}>
          <Col span={3}>
            <Breadcrumb className={styles.Topbread}>
              <Breadcrumb.Item><Link to="/">Нүүр</Link></Breadcrumb.Item>
              <Breadcrumb.Item>Админ</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col span={21} style={{ marginTop: 3 }}>
            <div className={styles.TopGuide}>
              <ul className={styles.productGuide}>
                <li> Нийт админ: <strong>{this.props.users.data ? this.props.users.data.total : ''}</strong></li>
              </ul>
              <Link to="/users/create" className={styles.createBtn}>
                <Button icon="plus" type="primary" size="small" style={{ fontSize: 13 }}>Админ нэмэх</Button>
              </Link>
            </div>
          </Col>
        </div>
      </Col>);

    return (
      <PageHeaderLayout
        style={{ padding: '0' }}
        top
        content={breadcrumb}
      >
        <Card bordered>
          <Row type="flex" justify="start">
            <Col span={24}>
              <Col span={12}>
                <span className={styles.pageHeading}>Админ</span>
              </Col>
              <Col span={12} style={{ marginBottom: 20 }}>
                <Col span={12} />
                <Col span={12}>
                  <Input.Search
                    placeholder="Админы нэрээр хайх.."
                    size="small"
                    value={this.state.search}
                    onChange={event => this.onChange({}, event.target.value)}
                  />
                </Col>
              </Col>
            </Col>
            {/* <Col span={24}>
              <div style={{ marginTop: 20 }}>
                <div style={{ width: '100%', float: 'left', marginBottom: 20 }}>
                  <Col span={6}>
                    <div style={{ paddingRight: 10 }} />
                  </Col>
                </div>
              </div>
            </Col> */}
          </Row>
          <Table
            className={styles.dataTable}
            rowKey={record => record.id}
            columns={this.columns}
            onChange={this.onChange}
            dataSource={this.props.users.data ? this.props.users.data.list.filter(entry => ((entry.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1) || (entry.email.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1) || (entry.tel.toString().toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1))) : []}
            /* dataSource={this.props.users.data ? this.props.users.data.list : []} */
            pagination={{ current: this.state.current, pageSize: this.state.limit, total: this.props.users.total }}
            loading={this.props.users.isLoading}
            style={{ borderBottom: '1px solid #eceeef' }}
            scroll={{ x: 990 }}
          />
        </Card>
      </PageHeaderLayout>
    );
  }
}

const mapStateToProps = state => ({
  users: state.user,
});

const mapDispatchToProps = {
  getUsers: User.list,
  removeUser: User.remove,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersContainer);



// WEBPACK FOOTER //
// ./src/containers/Users/List/index.js